import React from "react";
import { Card } from "react-bootstrap";
import { formatCurrency } from "../../../utils";

interface ActiveCurrency {
  currency: string;
  amount: number;
  value: number;
}

interface TotalEarnedCardProps {
  activeCurrencies: ActiveCurrency[];
}

const TotalEarnedCard: React.FC<TotalEarnedCardProps> = ({ activeCurrencies }) => {
  return (
    <Card className="border-0 rounded-3 bg-white p-4 h-100">
      <h5 className="mb-3">Total para el periodo actual</h5>
      {activeCurrencies.length > 0 ? (
        <div className="mb-3">
          {activeCurrencies.map((curr) => (
            <div key={curr.currency} className="d-flex align-items-center gap-2 mb-2">
              <span className="text-muted">{curr.currency}:</span>
              <h4 className="mb-0">{formatCurrency(curr.value, curr.currency)}</h4>
            </div>
          ))}
        </div>
      ) : (
        <h2 className="mb-3 text-muted">Sin bonos acumulados</h2>
      )}
      <p className="mb-0">
        <i className="ri-information-line text-primary me-1"></i>
        Los bonos se calculan semanalmente basados en los puntos acumulados por tu primer equipo.
      </p>
    </Card>
  );
};

export default TotalEarnedCard;
